import { Box, Typography } from '@mui/material';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        padding: { xs: 1.5, sm: 2 },
        marginTop: 'auto',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontSize: '0.875rem',
          }}
        >
          © {year} Rojan Thomas
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
